import { useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { apiGet } from '../services/apiClient';
import PackageEnquiryForm from '../components/packages-listing/PackageEnquiryForm';

const PackageEnquiryPage = () => {
  const { packageSlug } = useParams();
  const [searchParams] = useSearchParams();
  const [pkg, setPkg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const initialValues = useMemo(
    () => ({
      travelStartDate: searchParams.get('startDate') || '',
      travelEndDate: searchParams.get('endDate') || '',
      preferredMonth: searchParams.get('preferredMonth') || '',
      travellersCount: searchParams.get('travellers') || '',
      budgetMin: searchParams.get('budgetMin') || '',
      budgetMax: searchParams.get('budgetMax') || '',
      utmSource: searchParams.get('utm_source') || searchParams.get('utmSource') || '',
      utmCampaign: searchParams.get('utm_campaign') || searchParams.get('utmCampaign') || '',
    }),
    [searchParams]
  );

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    apiGet(`/api/public/packages/${packageSlug}`)
      .then((res) => {
        if (!active) return;
        const data = res?.data || res || null;
        setPkg(data);
      })
      .catch((err) => {
        if (!active) return;
        setError(err.message || 'Unable to load package.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [packageSlug]);

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-5xl px-4 py-10">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-amber-600">Packages</p>
            <h1 className="mt-2 text-2xl font-semibold text-slate-900">Package enquiry</h1>
            <p className="mt-1 text-sm text-slate-500">Share your preferences and we will tailor the trip.</p>
          </div>
          <Link
            to="/packages/list"
            className="rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-600"
          >
            Back to packages
          </Link>
        </div>

        <div className="mt-6 rounded-3xl border border-slate-200 bg-white p-6">
          {loading && <div className="text-sm text-slate-500">Loading package details...</div>}
          {error && <div className="text-sm text-rose-600">{error}</div>}
          {!loading && !error && pkg ? (
            <PackageEnquiryForm pkg={pkg} source="DETAILS" initialValues={initialValues} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PackageEnquiryPage;
